'use strict';

var ChartControlsBoardDirective = function ChartControlsBoardDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/chart-controls-board.html'),
    controller: 'ChartControlsBoardController',
    scope: {
      contextData: '=',
      getReferenceEntity: '&',
      removeReferenceEntity: '&'
    }
  };
};
ChartControlsBoardDirective.$inject = [];
module.exports = ChartControlsBoardDirective;